import { getIconByName } from "../icon/get-icon-by-name.js";
import { IconTile } from "../icon-tile/IconTile.js";
import stepper_module_default from "./stepper.module.js";
import { Stepper } from "@mantine/core";
import "react";
import { jsx } from "react/jsx-runtime";

//#region src/components/stepper/Stepper.tsx
const Stepper$1 = ({ steps, ...props }) => /* @__PURE__ */ jsx(Stepper, {
	classNames: stepper_module_default,
	...props,
	children: steps.map(({ iconProps, branching, ...step }, i) => /* @__PURE__ */ jsx(Stepper.Step, {
		icon: iconProps ? /* @__PURE__ */ jsx(IconTile, {
			Icon: getIconByName(iconProps.name),
			color: iconProps.color ?? "gray",
			size: "sm",
			shape: "circle"
		}) : void 0,
		classNames: branching ? { step: stepper_module_default.branchingStep } : void 0,
		...step
	}, i))
});

//#endregion
export { Stepper$1 as Stepper };